class SpeedmaxHeader {
  constructor() {
    this.header = document.querySelector('.speedmax-header');
    this.drawer = document.querySelector('.speedmax-header-drawer');
    this.mobileToggle = document.querySelector('.speedmax-header__mobile-toggle');
    this.stickyType = this.header?.dataset.sticky || 'none';
    this.lastScrollY = 0;
    
    this.init();
  }

  init() {
    if (!this.header) return;

    this.setupMobileDrawer();
    this.setupStickyHeader();
    this.setupSearchForm();
  }

  setupMobileDrawer() {
    if (!this.mobileToggle || !this.drawer) return;

    this.mobileToggle.addEventListener('click', () => {
      this.drawer.show();
    });

    this.drawer.addEventListener('sl-show', () => {
      document.body.style.overflow = 'hidden';
    });

    this.drawer.addEventListener('sl-hide', () => {
      document.body.style.overflow = '';
    });
  }

  setupStickyHeader() {
    if (this.stickyType === 'none') return;

    this.header.classList.add('is-sticky');

    if (this.stickyType === 'always') {
      this.header.classList.add('is-sticky-always');
      return;
    }

    if (this.stickyType === 'on-scroll-up') {
      this.header.classList.add('is-sticky-on-scroll-up');
      window.addEventListener('scroll', () => this.handleScrollUp(), { passive: true });
    }
  }

  handleScrollUp() {
    const currentScrollY = window.scrollY;

    if (currentScrollY <= 0) {
      this.header.classList.remove('is-visible');
      return;
    }

    if (currentScrollY < this.lastScrollY) {
      this.header.classList.add('is-visible');
    } else {
      this.header.classList.remove('is-visible');
    }

    this.lastScrollY = currentScrollY;
  }

  setupSearchForm() {
    const searchForms = document.querySelectorAll('.speedmax-header__search form, .speedmax-header__mobile-search form');
    
    searchForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        const input = form.querySelector('input[type="search"]');
        if (input?.value.trim()) {
          const action = form.getAttribute('action') || '/search';
          form.setAttribute('action', `${action}`);
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SpeedmaxHeader();
});